var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOwnerreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#EDC409"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#333",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.813 8.063c0 .605-.073 1.157-.22 1.654-.143.494-.369.92-.677 1.279a3.005 3.005 0 01-1.187.827c-.483.19-1.061.284-1.734.284-.66 0-1.23-.095-1.714-.284A3.085 3.085 0 015.094 11a3.445 3.445 0 01-.693-1.284 5.745 5.745 0 01-.225-1.665c0-.816.134-1.525.403-2.127a3.01 3.01 0 011.256-1.402c.566-.333 1.29-.5 2.17-.5.896 0 1.622.167 2.181.5.562.333.974.803 1.235 1.408.262.605.393 1.316.393 2.132zm-5.403 0c0 .473.054.88.161 1.22.108.34.278.6.51.783.233.183.538.274.914.274.39 0 .7-.091.929-.274.233-.182.4-.444.5-.784.103-.34.155-.746.155-1.219 0-.709-.118-1.27-.354-1.681-.237-.412-.643-.618-1.22-.618-.383 0-.693.093-.929.28-.233.186-.403.45-.51.794a4.26 4.26 0 00-.156 1.225z",
    fill: "#fff"
  })));
}
export default SvgOwnerreact;